import React from 'react';
import { Container, Image, Grid, Select } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { fetchCollections } from '../actions'
import YearToDate from './YearToDate';
import Monthly from './Monthly';
import Header from './Header';

class Collections extends React.Component{
    componentDidMount(){
        if(this.props.user){
            this.props.fetchCollections(this.props.year, this.props.token);
        }
    }
    render(){
        // const yearOptions = [
        //     {key: '2008', value: '2008', text: '2008'},
        //     {key: '2009', value: '2009', text: '2009'},
        //     {key: '2010', value: '2010', text: '2010'},
        //     {key: '2011', value: '2011', text: '2011'},
        //     {key: '2012', value: '2012', text: '2012'},
        //     {key: '2013', value: '2013', text: '2013'},
        //     {key: '2014', value: '2014', text: '2014'},
        //     {key: '2015', value: '2015', text: '2015'},
        //     {key: '2016', value: '2016', text: '2016'},
        //     {key: '2017', value: '2017', text: '2017'},
        //     {key: '2018', value: '2018', text: '2018'},
        //     {key: '2019', value: '2019', text: '2019'},
        //     {key: '2020', value: '2020', text: '2020'},
        //     {key: '2021', value: '2021', text: '2021'},
        //     {key: '2022', value: '2022', text: '2022'},
        //     {key: '2023', value: '2023', text: '2023'},
        //     {key: '2024', value: '2024', text: '2024'},
        //     {key: '2025', value: '2025', text: '2025'}
        // ]

        const startYear = 2008;
        const currentYear = new Date().getFullYear();

        const yearOptions = Array.from(
        { length: currentYear - startYear + 1 },
        (_, i) => {
            const year = String(currentYear - i);
            return { key: year, value: year, text: year };
        }
        );

        if(this.props.isSignedIn){
            return (
                <div>
                    <Header></Header>
                    <Container>
                        <Grid divided='vertically'>
                        <Grid.Row columns={1}><Select placeholder={`${this.props.year}`} options={yearOptions} onChange={(event, data) => this.props.fetchCollections(data.value, this.props.token)}></Select></Grid.Row>
                        </Grid>
                        
                        <YearToDate/>
                        <Monthly/>
                        </Container> 
                </div>
            )
        }else{
            return (
                <div>
                    <Header></Header>
                    <Container><br/><br/><br/><br/><Image src='/imonggo_full_logo.png' fluid verticalAlign='middle'/></Container>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return { 
        isSignedIn: state.auth.isSignedIn,
        token: state.auth.token,
        year: state.dashboard.year
     }
}
export default connect(mapStateToProps, {fetchCollections})(Collections);